import { Configuration, TestDecisionTexts } from "@/shared-module/models";
import { ConfigurationService } from "@/shared-module/services";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { SubSink } from "subsink";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormControl, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-create-test-decision-dialog",
  templateUrl: "createtestdecisiondialog.component.html",
})
export class CreateTestDecisionDialogComponent {
  @ViewChild("template", { static: true }) template;
  @ViewChild("content", { static: true }) content;
  @Input() texts: TestDecisionTexts;
  @Input() data: any;
  @Output() confirmed: EventEmitter<string> = new EventEmitter();

  subs = new SubSink();
  rgbColor: string;
  cssColor: string;
  environmentForm: FormGroup;
  modalReference: any;

  constructor(
    private configurationService: ConfigurationService,
    private modalService: NgbModal,
  ) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.rgbColor = c?.rgb;
        thisObject.cssColor = c.cssColor;
      },
    );
  }

  ngOnInit() {
    this.environmentForm = new FormGroup({
      environmentName: new FormControl("", [Validators.required]),
    });
  }

  get environmentName() {
    return this.environmentForm.get("environmentName");
  }

  open() {
    this.modalReference = this.modalService.open(this.content, {
      ariaLabelledBy: "modal-basic-title",
      windowClass: "modal-full modal-smaller modal-dialog-scrollable",
      size: "l",
      backdrop: "static",
      keyboard: false,
    });
  }

  onSubmit() {
    this.confirmed.emit(this.environmentName.value);
    this.modalReference.close();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
